// Utilities
import { createSimpleFunctional } from "../../util/index.js";
export const VListImg = createSimpleFunctional('v-list-img');
//# sourceMappingURL=VListImg.js.map